import '../App.css';
import { useContext } from 'react';
import { Routes, Route, Link, useParams, useLocation } from "react-router-dom";
import Home from './Home';
import OrderHistory from './OrderHistory';
import OrderDetails from './OrderDetails';
import ManageProducts from './ManageProducts';
import ManageCustomers from './ViewCustomers';
import ViewInventoryHistory from './ViewInventoryHistory';
import AddProduct from './AddNewProduct';
import CustomerOrderHistory from './CustomerOrder';
import EditProduct from './EditProduct';
import ManageStaff from './ManageStaff';
import ManageStore from './ManageStore';
import WalkIns from './WalkIns';
import { RiHome6Line } from "react-icons/ri";
import { TbHistoryToggle } from "react-icons/tb";
import { MdOutlineLocalConvenienceStore, MdOutlineStore, MdOutlineWarehouse } from "react-icons/md";
import { UserContext } from "../context/UserContext";
import { MenuContext } from '../context/MenuContext';
import { AiOutlineClose } from "react-icons/ai";
import club_logo from '../images/Full-Colour Wordmark PNG.png'
import { FaStore, FaUsers } from 'react-icons/fa';
import { LuUserPlus } from "react-icons/lu";
import { IoKey } from 'react-icons/io5';

export default function Dashboard() {
  const location = useLocation();
  const {logOutFunction} = useContext(UserContext);
  const { menuOpen, setMenuOpen } = useContext(MenuContext)

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <div className="py-3 px-0 md:px-1 bg-[#f1f1f1]">
        <aside className={`transition-transform duration-500 fixed lg:relative top-0 bottom-0 h-full z-[50] lg:z-[0] w-64 bg-white text-white p-6 space-y-4 ${menuOpen ? 'flex' : 'hidden lg:flex'} flex-col justify-start`}>
          <div className='flex flex-col justify-start items-center gap-y-2 w-full mt-[10px] mb-[20px]'>
              <div
                  onClick={() => setMenuOpen(false)}
                  className="block lg:hidden btn btn-ghost btn-circle mb-4 self-end fixed"
              >
                  <AiOutlineClose className="h-7 w-7 text-black" />
              </div>
              <img src={club_logo} className="h-auto w-[80%] mx-auto" alt="logo" />
          </div>
          <nav className="flex flex-col space-y-2 gap-y-1">
            <Link to="/dashboard/home" className={`py-2 flex gap-x-3 items-center px-3 hover:text-white hover:bg-secondary rounded-[7px] ${(location.pathname.startsWith("/dashboard/home")) ? 'bg-primary text-white' : 'text-black'}`} ><RiHome6Line size={20} color={`${(location.pathname.startsWith("/dashboard/home")) ? '#ffffff' : '#222222'}`} /> Home</Link>
            <Link to="/dashboard/order-history" className={`py-2 flex gap-x-3 items-center px-3 hover:text-white hover:bg-secondary rounded-[7px] ${(location.pathname.startsWith("/dashboard/order-history")) ? 'bg-primary text-white' : 'text-black'}`} ><TbHistoryToggle size={20} color={`${location.pathname.startsWith("/dashboard/order-history") ? '#ffffff' : '#222222'}`} /> Order History</Link>
            <Link to="/dashboard/walk-ins" className={`py-2 flex gap-x-3 items-center px-3 hover:text-white hover:bg-secondary rounded-[7px] ${(location.pathname.startsWith("/dashboard/walk-ins")) ? 'bg-primary text-white' : 'text-black'}`}><MdOutlineStore size={20} color={`${(location.pathname.startsWith("/dashboard/walk-ins")) ? '#ffffff' : '#222222'}`} /> Checkout</Link>
            <Link to="/dashboard/manage-products" className={`py-2 flex gap-x-3 items-center px-3 hover:text-white hover:bg-secondary rounded-[7px] ${(location.pathname.startsWith("/dashboard/manage-products")) ? 'bg-primary text-white' : 'text-black'}`}><MdOutlineWarehouse size={20} color={`${(location.pathname.startsWith("/dashboard/manage-products")) ? '#ffffff' : '#222222'}`} /> Manage Products</Link>
            {/* {/* <Link to="/dashboard/list-apartment" className={`py-2 flex gap-x-3 items-center px-3 hover:text-white hover:bg-secondary rounded-[7px] ${(location.pathname == "/dashboard/list-apartment") ? 'bg-primary text-white' : 'text-black'}`}><PiBuildingApartment size={20} color={`${(location.pathname.startsWith("/dashboard/list-apartment")) ? '#ffffff' : '#222222'}`} /> List Apartment</Link> */}
            <Link to="/dashboard/member-customers" className={`py-2 flex gap-x-3 items-center px-3 hover:text-white hover:bg-secondary rounded-[7px] ${(location.pathname.startsWith("/dashboard/member-customers")) ? 'bg-primary text-white' : 'text-black'}`}><LuUserPlus size={20} color={`${(location.pathname.startsWith("/dashboard/member-customers")) ? '#ffffff' : '#222222'}`} /> Member Customers</Link>
            <Link to="/dashboard/store" className={`py-2 flex gap-x-3 items-center px-3 hover:text-white hover:bg-secondary rounded-[7px] ${(location.pathname.startsWith("/dashboard/store")) ? 'bg-primary text-white' : 'text-black'}`}><MdOutlineLocalConvenienceStore size={20} color={`${(location.pathname.startsWith("/dashboard/store")) ? '#ffffff' : '#222222'}`} /> Manage Outlets</Link>
            
            <div onClick={() => logOutFunction()} className={`py-2 px-3 hover:opacity-[0.8] text-[#ff0000] cursor-pointer hover:font-semibold rounded-[7px]`}>
              Log Out
            </div>
          </nav>
        </aside>
        {menuOpen && <div className={`${menuOpen ? 'flex lg:hidden' : 'hidden'} h-full w-full fixed top-0 bg-[#000000]/50 z-[49]`}>

        </div>}
      </div>

      {/* Main content */}
      <main className="max-h-screen overflow-y-auto flex-1 py-3 px-3 md:px-1 bg-[#f1f1f1]">
        {/* <ScrollToTop /> */}
        <Routes>
          <Route path="home" element={<Home />} />
          <Route path="order-history/details/:reference" element={<OrderDetails />} />
          <Route path="order-history" element={<OrderHistory />} />
          <Route path="manage-products" element={<ManageProducts />} />
          <Route path="manage-products/new-product" element={<AddProduct />} />
          <Route path="manage-products/edit-product/:product_id" element={<EditProduct />} />
          <Route path="member-customers" element={<ManageCustomers />} />
          <Route path="manage-products/inventory-history/:product_id/:product_name" element={<ViewInventoryHistory />} />
          <Route path="member-customers/orders/:customer_id" element={<CustomerOrderHistory />} />
          <Route path="store/staff/:location_id" element={<ManageStaff />} />
          <Route path="store" element={<ManageStore />} />
          <Route path="walk-ins" element={<WalkIns />} />
        </Routes>
      </main>
    </div>
  );
}

